import Row from "src/components-v2/Grid/Row";
import Col from "src/components-v2/Grid/Col";
import Shimmer from "src/components-v2/Shimmer";

import { repeatComponent } from "src/helpers/component";
import { useIsMobileWidth } from "src/hooks/window";

export default function StepsShimmer({ amount = 4 }) {
  const isMobileWidth = useIsMobileWidth();

  return (
    <Row>
      {repeatComponent(
        isMobileWidth ? 1 : amount,
        <Col md={3}>
          <Shimmer width="100%" height={20} />
        </Col>
      )}
    </Row>
  );
}
